module.exports = __webpack_public_path__ + "img/pipeline.361bfb7f.png";